import styled from 'styled-components'

export const CardRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
  border-radius: 16px;
  background: ${p => p.theme.palette.colors.backgroundStrong};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  box-shadow: 0 18px 34px ${p => p.theme.palette.colors.shadowStrong};
  overflow: hidden;
`;

export const HeaderTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 18px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const HeaderMeta = styled.div.attrs({})`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.subdued};
`;

export const HeaderBlock = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
`;

export const ListScroll = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 0;
  max-height: 520px;
  overflow-y: auto;
  padding-right: 6px;
  padding-bottom: 10px;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(153, 161, 175, 0.45);
    border-radius: 999px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(153, 161, 175, 0.7);
  }

  @media(max-width: 991px){
    max-height: none;
    overflow: visible;
    padding-right: 0;
  }
`;

export const ModuleGroup = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const ModuleHeader = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
  padding: 16px 20px 10px;
  font-family: Gilroy;
  font-size: 14px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const ModuleTime = styled.div.attrs({})`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.subdued};
  white-space: nowrap;
`;

export const LessonButton = styled.button.attrs({})`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-radius: 0;
  border: 0;
  border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};
  background: ${p => p.active ? p.theme.palette.colors.surfaceSoft : p.theme.palette.colors.backgroundStrong};
  cursor: pointer;
  text-align: left;
  transition: background 0.18s ease;

  &:hover {
    background: ${p => p.theme.palette.colors.surfaceSoft};
  }
`;

export const LessonIcon = styled.div.attrs({})`
  width: 38px;
  min-width: 38px;
  height: 38px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.active ? p.theme.palette.blue.main : p.theme.palette.colors.badgeMuted};
`;

export const LessonText = styled.div.attrs({})`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const LessonTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 15px;
  line-height: 1.25;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

export const LessonMeta = styled.div.attrs({})`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-family: Lato;
  font-size: 13px;
  line-height: 1.4;
  font-weight: 400;
  color: ${p => p.theme.palette.colors.subdued};
`;

export const LessonMetaDot = styled.span.attrs({})`
  width: 4px;
  height: 4px;
  border-radius: 999px;
  background: ${p => p.theme.palette.success.main};
`;

export const LessonMetaHighlight = styled.span.attrs({})`
  color: ${p => p.theme.palette.success.main};
  font-weight: 700;
`;

export const RightActions = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 8px;
`;

export const ActionButton = styled.button.attrs({})`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
`;
